/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 */

// Cookie functions from w3schools

/* global window, document, Event */

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

export function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function initCookie() {
  const cookieAlert = document.querySelector('.cookiealert');
  const acceptCookies = document.querySelector('.acceptcookies');

  if (!cookieAlert) {
    return;
  }

  // eslint-disable-next-line no-unused-expressions
  cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

  // Show the alert if we cant find the "acceptCookies" cookie
  if (!getCookie('acceptCookies')) {
    cookieAlert.classList.add('show');
  }

  // When clicking on the agree button, create a 1 year
  // cookie to remember user's choice and close the banner
  acceptCookies.addEventListener('click', () => {
    setCookie('acceptCookies', true, 365);
    cookieAlert.classList.remove('show');

    // dispatch the accept event
    window.dispatchEvent(new Event('cookieAlertAccept'));
  });
}

export default function def() {
  initCookie();
}
